import React, { useState } from "react";
import FollowUpNotesForm from "./FollowUpNotes";
import FollowUpHistory from "./FollowUpHistory";

const FollowUpCard = ({ lead_id }) => {
  const [activeTab, setActiveTab] = useState("form");

  return (
    <div className="w-full max-w-2xl">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="flex border-b border-gray-200">
          <button
            className={`flex-1 py-4 px-6 text-sm font-medium ${
              activeTab === "form"
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("form")}
          >
            Follow-up Form
          </button>
          <button
            className={`flex-1 py-4 px-6 text-sm font-medium ${
              activeTab === "history"
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveTab("history")}
          >
            History
          </button>
        </div>
        <div className="p-6">
          {activeTab === "form" ? (
            <FollowUpNotesForm lead_id={lead_id} />
          ) : (
            <FollowUpHistory lead_id={lead_id} />
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowUpCard;
